import md5 from 'js-md5'
import { getNowFormatDate } from '@/util/tools'

export const setSign = (params) => {
    const ciphertext = 'btr888';//密文
    const arr = params.split('&');
    let tempArr = [];
    arr.forEach(ele => {
        let v = decodeURIComponent(ele.split('=')[1]);
        if(typeof v === 'string'){
            v = v.trim();
        }else{
        }
        let tempObj = {
            key :ele.split('=')[0],
            val : v,
        };
        if(tempObj.val){
            tempArr.push(tempObj);
        }
    });
    tempArr.sort(compare);
    let res = '';
    tempArr.forEach(ele => {
        res += ele.key + '=' + ele.val + '&';
    });
    const nowDate = getNowFormatDate();
    res += nowDate+ '&' + ciphertext;
    return md5(res);
};

/**
 * 数组字符顺序排序
 * @param val1
 * @param val2
 * @returns {number}
 */
const compare = (val1, val2) => {
    return val1.key.toLowerCase() > val2.key.toLowerCase() === true ? 1 : -1;
};
